import { Box, Flex, HStack, Tag, Text, VStack } from '@chakra-ui/react';
import { TransactionNotificationLogFragment } from '@client/graphql/__generated__/types';
import dayjs from 'dayjs';
import { FC } from 'react';
import { contactTypeLabels } from './contactTypeLabels';

interface SmsPreviewProps {
  notification: TransactionNotificationLogFragment;
}

export const SmsPreview: FC<SmsPreviewProps> = ({ notification }) => {
  const sentAt = notification.sentAt as string;

  return (
    <VStack alignItems="stretch" spacing={0}>
      {/* iPhone-style SMS bubble */}
      <Flex justifyContent="flex-start" px={2}>
        <Box
          bg="gray.600"
          borderBottomLeftRadius="4px"
          borderBottomRightRadius="2xl"
          borderTopLeftRadius="2xl"
          borderTopRightRadius="2xl"
          maxW="85%"
          px={4}
          py={3}
        >
          <Text
            color="white"
            fontSize="md"
            lineHeight="16px"
            whiteSpace="pre-wrap"
          >
            {notification.messageContent}
          </Text>
        </Box>
      </Flex>

      {/* Metadata */}
      <VStack alignItems="flex-start" px={2} spacing={3}>
        {notification.recipients.length > 0 && (
          <Box mt={6}>
            <Text color="whiteAlpha.500" fontSize="xs" mb={1}>
              SENT TO
            </Text>
            <VStack alignItems="flex-start" spacing={1}>
              {notification.recipients.map((recipient) => (
                <HStack key={recipient.id} spacing={2}>
                  <Text color="white" fontSize="sm">
                    {recipient.firstName} {recipient.lastName}
                  </Text>
                  <Tag
                    bg="whiteAlpha.100"
                    color="whiteAlpha.600"
                    fontSize="xs"
                    size="sm"
                  >
                    {contactTypeLabels[recipient.contactType] ||
                      recipient.contactType}
                  </Tag>
                  {recipient.phoneNumber && (
                    <Text color="whiteAlpha.500" fontSize="sm">
                      {recipient.phoneNumber}
                    </Text>
                  )}
                </HStack>
              ))}
            </VStack>
          </Box>
        )}

        {sentAt && (
          <Box mt={6}>
            <Text color="whiteAlpha.500" fontSize="xs" mb={1}>
              SENT AT
            </Text>
            <Text color="white" fontSize="sm">
              {dayjs(sentAt).format('dddd, MMMM D, YYYY [at] h:mm A')}
            </Text>
          </Box>
        )}
      </VStack>
    </VStack>
  );
};
